common.View.create('shop::website.modules.shopProducts.index.Sort', {

    onDOMLoad()
    {
        this.initSorting();
    },

    initSorting()
    {
        this.element

            // Listen for sort change.
            .find('a')
                .click(() => {
                    this.getIndexInstance().onUserInput();

                    return false;
                })
                .end();
    },

    getIndexInstance()
    {
        return shop.website.modules.shopProducts.Index.getInstance(this);
    },

    getSortQuery()
    {
        // Get sort value.
        let sortValue = Alpine.store('sort').sort;

        // Is custom sort?
        if(sortValue)
            return {
                sort: sortValue,
            };

        // Is default sort? No need to be in the url.
        else
            return {};
    },

});
